import { routes as visitRoutes } from "./visit/routes";
import { routes as vitalRoutes } from "./vitals/routes";

export const routes = [
    ...visitRoutes(`visits`),
    ...vitalRoutes(`visits`),
];
